import ApplicationSerializer from 'lumen/serializers/application';

export default class RoiTrophiesHighlightConfigSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string): string {
    if (key === 'highlight_config') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('roi-trophies/highlight-config');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  payloadKeyFromModelName(): string {
    return 'highlight_config';
  }
}
